import React from 'react'
import ReactGA from 'react-ga'
import classes from './Alphabet.scss'
import 'whatwg-fetch'

export default class Alphabet extends React.Component {

  constructor (props) {
    super(props)
    this.state = { bad: [], good: [], maybe: [], set: false }

    const self: any = this
    self.renderLetter = self.renderLetter.bind(self)
  }

  componentWillReceiveProps (nextProps) {
    const { alphabet } = nextProps
    const { set } = this.state

    if (alphabet === 'clear') {
      return this.setState({ good: [], bad: [], maybe: [] })
    }
    if (!alphabet || set) return;

    const keys = Object.keys(alphabet)
    const bad = []
    const good = []
    const maybe = []
    if (keys.length < 1) return;
    keys.forEach(key => {
      if (alphabet[key] === 'bad') {
        bad.push(key)
      } else if (alphabet[key] === 'good') {
        good.push(key)
      } else if (alphabet[key] === 'maybe') {
        maybe.push(key)
      }
    })
    this.setState({ good, bad, maybe, set: true })
  }

  toggleLetter (letter) {
    const { bad, good, maybe } = this.state
    const badIdx = bad.indexOf(letter)
    const goodIdx = good.indexOf(letter)
    const maybeIdx = maybe.indexOf(letter)
    let color = ''
    if (badIdx === -1 && goodIdx === -1 && maybeIdx === -1) { // no color
      bad.push(letter)
      color = 'bad'
    } else if (badIdx === -1 && maybeIdx === -1) { // good
      good.splice(goodIdx, 1)
      maybe.push(letter)
      color = 'maybe'
    } else if (goodIdx === -1 && maybeIdx === -1) { // bad
      bad.splice(badIdx, 1)
      good.push(letter)
      color = 'good'
    } else if (badIdx === -1 && goodIdx === -1) { // maybe
      maybe.splice(maybeIdx, 1)
    }
    this.updateAlphabet(letter, color)
    this.setState({ good, bad })
    // document.getElementById('guessText').focus() // disable for mobile
    ReactGA.event({ category: 'Game', action: 'Toggled letter' })
  }

  updateAlphabet (letter, color) {
    const { baseUrl, gameId, username } = this.props
    if (!username) { return }
    
    fetch(`${baseUrl}/game/${gameId}/update`, {
      method: 'POST',
      body: JSON.stringify({ letter, color }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result !== 'ok') {
          alert(res.err || res.message || res.msg)
        }
      })
  }

  renderLetter (letter) {
    const { good, bad, maybe } = this.state
    const letterStyle = [classes.letter, bad.indexOf(letter) > -1 && classes.bad, good.indexOf(letter) > -1 && classes.good, maybe.indexOf(letter) > -1 && classes.maybe].join(' ')
    return (
      <div key={letter} className={letterStyle} onClick={this.toggleLetter.bind(this, letter)}>{letter}</div>
    )
  }

  render () {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    return (
      <div className={classes.box}>
        {alphabet.map(this.renderLetter.bind(this))}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Alphabet/Alphabet.js
 **/